import { useSessionStorage } from 'support/react/hooks';

/**
 * Parameters for a custom finish button in embeds.
 */
export const useFinishButtonParameters = () => {
  return useSessionStorage<{ target: string; text: string; url: string }>('finish_button_parameters');
};
